import React from 'react';
import {
  Box,
  Grid,
  Typography,
  Avatar,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import GavelIcon from '@mui/icons-material/Gavel';
import HomeWorkIcon from '@mui/icons-material/HomeWork';

// Define a ReactNode type for icon instead of JSX.Element for compatibility
interface InfoItem {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const infoData: InfoItem[] = [
  {
    icon: <LocationCityIcon fontSize="large" />,
    title: 'This is why you should invest in Thane, of all places.',
    description:
      'Well, there are ample reasons to do so. The very first being, Thane’s strategic location. Away from the chaos of the suburbs of Mumbai; it has a charm of its own. While being peaceful, it enjoys all the perks of an urban life. Add to that, the area is well-connected to the important hubs of Mumbai and other parts of the state through major expressways and highways. And with the current property rates, an investment here makes for a valuable proposition.',
  },
  {
    icon: <VerifiedUserIcon fontSize="large" />,
    title: 'This is why a Raymond residence is the one for you.',
    description:
      'The Raymond name has been synonymous with top-notch quality in everything we do. With attention-to-detail in every aspect, there is an intrinsic sense of class. Your Raymond residence will be built with love, care and aesthetic ingenuity. It will imbibe and reflect these attributes, making it your dream abode.',
  },
  {
    icon: <GavelIcon fontSize="large" />,
    title:
      'This is the Legal information you should know while considering an investment.',
    description:
      'For bonafide residential purposes, an NRI with an active Indian passport does not need the approval of RBI to acquire an immovable property. You can make the purchase either by remittance of funds from abroad through normal banking channels or out of your NRO/ NRE/ FCNR account.',
  },
  {
    icon: <HomeWorkIcon fontSize="large" />,
    title: 'This is what you should know regarding Housing Loans.',
    description:
      'As an NRI, you are recognized under the Foreign Exchange Regulation Act, 1973. There are attractive NRI housing schemes facilitated by many banks in India. Several reputed Housing Finance Companies offer NRI focused housing finance plans with suitable repayment options.',
  },
];

const InfoGrid: React.FC = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ flexGrow: 1, padding: 4 }}>
      <Grid container spacing={6}>
        {infoData.map((item, index) => (
          <Grid item xs={12} md={6} key={index}>
            <Box display="flex" alignItems="flex-start">
              <Box position="relative" mr={2}>
                <Avatar
                  alt={item.title}
                  sx={{
                    width: 70,
                    height: 70,
                    border: '2px solid red',
                    backgroundColor: 'transparent',
                    color: 'red',
                  }}
                >
                  {item.icon}
                </Avatar>
                <Box
                  sx={{
                    position: 'absolute',
                    left: '50%',
                    top: '100%',
                    transform: 'translateX(-50%)',
                    width: '2px',
                    height: isSmallScreen ? '40px' : '60px',
                    backgroundColor: 'red',
                    mt: 1,
                  }}
                />
              </Box>
              <Box>
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  gutterBottom
                  sx={{ fontSize: '1rem' }}
                >
                  {item.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {item.description}
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default InfoGrid;
